import type { DateTime } from 'luxon'
import { defineStore } from 'pinia'
import type { TerminalName } from '~/services/apiClient'
import { ReturnRulesReading } from '~/models/returnRules'
import { EmptyReturnRulesApi } from '~/services/apiClient'

export const useReturnRulesHistory = defineStore(
  'empty-return-rules-readings-history',
  {
    state: () => {
      return {
        readings: [] as ReturnRulesReading[],
        loading: false,
      }
    },
    actions: {
      load({
        terminalName,
        observedAfter,
        observedBefore,
      }: {
        terminalName: TerminalName
        observedAfter?: DateTime
        observedBefore?: DateTime
      }) {
        this.readings = []
        this.loading = true
        const api = new EmptyReturnRulesApi()
        return api
          .getReadingsHistoryEmptyReturnRulesReadingsTerminalHistoryGet(
            terminalName,
            observedAfter?.toISO(),
            observedBefore?.toISO()
          )
          .then((resp) => {
            this.readings = resp.data.map((reading) => {
              return new ReturnRulesReading(reading)
            })
          })
          .finally(() => {
            this.loading = false
          })
      },
    },
  }
)
